"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./bracketTagEnum"), exports);
__exportStar(require("./card"), exports);
__exportStar(require("./cardDetail"), exports);
__exportStar(require("./cardInDeck"), exports);
__exportStar(require("./cardInDeckRequest"), exports);
__exportStar(require("./cardInVariant"), exports);
__exportStar(require("./cardLegalities"), exports);
__exportStar(require("./cardPrices"), exports);
__exportStar(require("./cardUsedInVariantSuggestion"), exports);
__exportStar(require("./cardUsedInVariantSuggestionRequest"), exports);
__exportStar(require("./combo"), exports);
__exportStar(require("./deck"), exports);
__exportStar(require("./deckRequest"), exports);
__exportStar(require("./estimateBracketResult"), exports);
__exportStar(require("./feature"), exports);
__exportStar(require("./featureOfCard"), exports);
__exportStar(require("./featureProducedByVariant"), exports);
__exportStar(require("./featureProducedInVariantSuggestion"), exports);
__exportStar(require("./featureProducedInVariantSuggestionRequest"), exports);
__exportStar(require("./featureStatusEnum"), exports);
__exportStar(require("./findMyCombosResponse"), exports);
__exportStar(require("./identityEnum"), exports);
__exportStar(require("./invalidUrlResponse"), exports);
__exportStar(require("./kindEnum"), exports);
__exportStar(require("./paginatedCardDetailList"), exports);
__exportStar(require("./paginatedFeatureList"), exports);
__exportStar(require("./paginatedFindMyCombosResponseList"), exports);
__exportStar(require("./paginatedFindMyCombosResponseListResults"), exports);
__exportStar(require("./paginatedTemplateList"), exports);
__exportStar(require("./paginatedUserDetailList"), exports);
__exportStar(require("./paginatedVariantAliasList"), exports);
__exportStar(require("./paginatedVariantList"), exports);
__exportStar(require("./paginatedVariantSuggestionList"), exports);
__exportStar(require("./paginatedVariantUpdateSuggestionList"), exports);
__exportStar(require("./paginatedWebsitePropertyList"), exports);
__exportStar(require("./patchedUserDetailRequest"), exports);
__exportStar(require("./patchedVariantSuggestionRequest"), exports);
__exportStar(require("./patchedVariantUpdateSuggestionRequest"), exports);
__exportStar(require("./suggestionStatusEnum"), exports);
__exportStar(require("./template"), exports);
__exportStar(require("./templateInVariant"), exports);
__exportStar(require("./templateRequiredInVariantSuggestion"), exports);
__exportStar(require("./templateRequiredInVariantSuggestionRequest"), exports);
__exportStar(require("./tokenObtainPair"), exports);
__exportStar(require("./tokenObtainPairRequest"), exports);
__exportStar(require("./tokenRefresh"), exports);
__exportStar(require("./tokenRefreshRequest"), exports);
__exportStar(require("./tokenVerifyRequest"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./userDetail"), exports);
__exportStar(require("./userDetailRequest"), exports);
__exportStar(require("./userRequest"), exports);
__exportStar(require("./variant"), exports);
__exportStar(require("./variantAlias"), exports);
__exportStar(require("./variantInVariantUpdateSuggestion"), exports);
__exportStar(require("./variantInVariantUpdateSuggestionRequest"), exports);
__exportStar(require("./variantLegalities"), exports);
__exportStar(require("./variantPrices"), exports);
__exportStar(require("./variantStatusEnum"), exports);
__exportStar(require("./variantSuggestion"), exports);
__exportStar(require("./variantSuggestionRequest"), exports);
__exportStar(require("./variantUpdateSuggestion"), exports);
__exportStar(require("./variantUpdateSuggestionRequest"), exports);
__exportStar(require("./variantsQueryValidationError"), exports);
__exportStar(require("./websiteProperty"), exports);
__exportStar(require("./zoneLocationsEnum"), exports);
//# sourceMappingURL=index.js.map